import {WfApproveRequest} from './request/WfApproveRequest';

export class Absence {
    totalCount?: number;
    id: number;
    employeeId: number;
    absenceDay: number;
    absenceTypeId: number;
    absenceTypeName: string;
    absenceStartDate: string;
    absenceEndDate: string;
    description: string;
    filePath: string;
    freeDayAmount: number;
    readAndAprroved: number;
    name: string;
    surname: string;
    departmentName: string;
    departmentId: number;
    absenceExcuseReasonId: number;
    isCompleted: number;
    rejectReasonId: number;
    rejectDescription: string;
    anyManagerApproved: number;
    proxyManager: any;
    isNew?: boolean;
    tabNo?: number;
}

export class AbsenceRejectRequest extends WfApproveRequest {
    rejectReasonId?: number;
    rejectDescription?: string;
}

